import { render, staticRenderFns } from "./NormalSearchNav198.vue?vue&type=template&id=8672517c&scoped=true"
import script from "./NormalSearchNav198.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav198.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8672517c",
  null
  
)

export default component.exports